<template>
  <div class="ui-header-dropdown-menu component">
    <div class="close-trigger">
      <div class="close-line left"></div>
      <div class="close-line right"></div>
    </div>
    <UiBaseMenuDropdown>
      <ul class="menu">
        <li class="menu-item"><router-link :to="{ name: 'index' }" exact>home</router-link></li>
        <li class="menu-item"><router-link :to="{ name: 'intro' }">intro</router-link></li>
        <li class="menu-item"><router-link :to="{ name: 'portfolio' }">portfolio</router-link></li>
        <li class="menu-item"><router-link :to="{ name: 'contact' }">contact</router-link></li>
      </ul>
    </UiBaseMenuDropdown>
  </div>
</template>

<script>
  import UiBaseMenuDropdown from './UiBaseMenuDropdown'

  export default {
    name: 'UiHeaderDropdownMenu',
    components: { UiBaseMenuDropdown }
  }
</script>
<style lang="scss">
  .ui-header-dropdown-menu {
    position: relative;
    z-index: 9;

    .content {
      background: $prime-color;
      color: $white;
      min-width: 100vw;
      width: 100%;
      min-height: 100vh;
      height: 100%;
      position: fixed;
      top: 0;
      right: 0;
      background-color: $light-prime;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .close-trigger {
    cursor: pointer;
    position: absolute;
    width: 42px;
    height: 42px;
    right: 20px;
    top: 0;

    &:hover {
      .menu-line {
        &:before {
          width: 100%;
        }
      }

      .close-trigger {
        &:before {
          width: 100%;
        }
      }
    }

    .close-line {
      display: block;
      width: 100%;
      height: 4px;
      background-color: $dark-color;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 0;
        height: 100%;
        background-color: $white;
        transition: $slide;
      }

      &.left {
        transform: translateX(100px) translateY(-100px) rotate(-45deg);
      }
      &.right {
        transform: translateX(-100px) translateY(-100px) rotate(45deg);
        top: -3px;
      }
    }
  }

  @keyframes line {
    0% {
      background-position-x: 390px;
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/UiHeaderDropdownMenu.vue